const planetas =  [
    {
      "icone": "marte.png",
      "titulo": "Primeira missão",
      "subtitulo": "Construindo uma cidade inteligente em Marte",
      "teste_final_id": 1
    },
    {
      "icone": "venus.png",
      "titulo": "Segunda Missão",
      "subtitulo": "Construindo uma plantação inteligente em Vênus",
      "teste_final_id": 2
    },
    {
      "icone": "mercurio.png",
      "titulo": "Terceira Missão",
      "subtitulo": "Construindo uma casa inteligente em Mercúrio",
      "teste_final_id": 4
    },
    {
      "icone": "jupiter.png",
      "titulo": "Quarta Missão",
      "subtitulo": "Levando cultura maranhense para Júpiter",
      "teste_final_id": 3
    },
    {
      "icone": "saturno.png",
      "titulo": "Quinta Missão",
      "subtitulo": "Construindo jogos em Saturno",
      "teste_final_id": 5
    },
    {
      "icone": "urano.png",
      "titulo": "Sexta Missão",
      "subtitulo": "Automatizando carros em Urano",
      "teste_final_id": 6
    },
    {
      "icone": "netuno.png",
      "titulo": "Sétima Missão",
      "subtitulo": "Acessibilidade em Netuno",
      "teste_final_id": 7
    },
    {
      "icone": "terra.png",
      "titulo": "Oitava Missão",
      "subtitulo": "Sustentabilidade na Terra",
      "teste_final_id": 8
    }
]

function findPlanetas(){
  return planetas;
}

export default findPlanetas
